<template>
  <footer class="main-footer">
    <div class="main-footer-wrapper">
      <div class="left">
        <div class="left-header">
          <img src="@/assets/images/cc-logos.png">
        </div>
        <nav>
          <p>
            <router-link to="/">Home</router-link>
            <router-link to="/how-it-works">How it Works</router-link>
            <router-link to="/for-students">Students</router-link>
            <router-link to="/for-nerds">Nerds</router-link>
          </p>
          <p>
            <router-link to="/terms-of-service">Terms of Use</router-link>
            <router-link to="/privacy">Privacy Policy</router-link>
            <router-link to="/refund-policy">Refund Policy</router-link>
            <router-link to="/honor-code">Honor Code</router-link>
          </p>
        </nav>
      </div>
      <div class="right">
        <img src="@/assets/images/security.png">
        <div class="right-text">
          <div>
            <p>
              Send us an email to: <a href="mailto:help@nerdhire.co">help@nerdhire.co</a>
            </p>
            <p>By accessing this website you agree to our Terms of Use, Privacy and Cookie Policies.</p>
          </div>
          <icon name="nerdhire-logo-white" />
        </div>
      </div>
    </div>

    <div class="m-app-footer">
      <div class="m-app-footer-pay">
        <img src="@/assets/images/cc-logos.png">
        <router-link to="/pay">PAY</router-link>
      </div>
      <div class="m-app-footer-nav">
        <p>
          <router-link to="/">Home</router-link>
          <router-link to="/how-it-works">How it Works</router-link>
          <router-link to="/for-students">Students</router-link>
        </p>
        <p>
          <router-link to="/for-nerds">Nerds</router-link>
          <router-link to="/terms-of-service">Terms of Use</router-link>
          <router-link to="/privacy">Privacy Policy</router-link>
        </p>
        <p>
          <router-link to="/refund-policy">Refund Policy</router-link>
          <router-link to="/honor-code">Honor Code</router-link>
        </p>
      </div>
      <div class="m-app-footer-logos">
        <img src="@/assets/images/security.png" class="mcaffree">
        <icon name="nerdhire-logo-white" />
      </div>
      <div class="m-app-footer-text">
        <p>Send us an email to: <a href="mailto:help@nerdhire.co">help@nerdhire.co</a> or call us at: (800) 674-3248</p>
        <p>The address is 37 E 7th St., New York, NY 10003</p>
        <p>By accessing this website you agree to our Terms of Use, Privacy and Cookie Policies.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import Icon from '@/components/Icon'
export default {
  components: {
    Icon
  }
}

setTimeout(myChat, 2000)
function myChat () {
  document.getElementById('chat_btn').addEventListener('click', function () {
    document.getElementsByClassName('cc-xkyq')[0].click()
  })
}

setTimeout(myChatMob, 2000)
function myChatMob () {
  document.getElementById('chat_btn_mob').addEventListener('click', function () {
    document.getElementsByClassName('cc-xkyq')[0].click()
  })
}

</script>

<style lang="scss">
  @import '~@/styles/media';

  #crisp-chatbox .cc-dc5e[aria-label='Open chat'] {
    visibility: hidden !important;
    display: none !important;
  }

  .main-footer {
    color: var(--primary-white);
    background-color: var(--primary-black);
    padding: 60px 0;
    z-index: 100000;
    position: relative;

    &-wrapper {
      max-width: 1000px;
      margin: 0 auto;
      padding: 0 40px;
      display: grid;
      grid-template-columns: 1fr auto;

      .left {
        &-header {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-column-gap: 40px;
        }

        .pay-btn {
          background-color: var(--primary-green);
          border-radius: 4px;
          width: 114px;
          height: 40px;
          line-height: 41px;
          text-align: center;
          display: inline-block;
          box-sizing: border-box;
          color: var(--primary-white);
          transition: background-color .2s ease-out;

          &:hover {
            border: none;
            background-color: var(--primary-green-hover);
            color: var(--primary-white);
          }
        }

        nav {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-column-gap: 85px;
        }

        img {
          width: 260px;
          margin-bottom: 20px;
        }

        a {
          font-size: 12px;
          color: var(--primary-white);
          text-decoration: none;
          display: block;
          line-height: 1.9;
          transition: color .2s ease-in-out;

          &:hover {
            color: var(--primary-yellow);
          }
        }
      }

      .right {
        text-align: right;
        font-size: 10px;

        &-text {
          margin-top: 20px;
          display: grid;
          grid-template-columns: 1fr auto;
          grid-column-gap: 30px;
          align-items: end;

          svg {
            width: 90px;
          }
        }

        .callus {
          text-decoration: none;
        }

        a {
          color: var(--fb-blue);
        }

        p {
          margin: 5px 0;
        }

        img {
          width: 242px;
        }

        .nd-logo {
          width: 68px;
        }
      }
    }

    @media #{$mobile} {
      padding: 0;
      &-wrapper { display: none };
    }

    @media #{$desktop} {
      &-wrapper { display: grid };
    }
  }
</style>

<style lang="scss">
  @import '~@/styles/media';

  .m-app-footer {
    color: var(--primary-white);
    background-color: var(--primary-black);
    padding: 30px 20px 20px;

    &-pay {
      display: grid;
      grid-template-columns: 1fr auto;
      margin-bottom: 10px;

      img {
        width: 215px;
      }

      a {
        background-color: var(--pay-btn-blue);
        color: var(--primary-white);
        text-decoration: none;
        border-radius: 4px;
        width: 77px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
      }
    }

    &-nav {
      display: grid;
      grid-template-columns: 1fr 1fr auto;

      p {
        padding: 0!important;
      }

      a {
        color: var(--primary-white);
        text-decoration: none;
        font-size: 12px;
        display: block;
        margin-bottom: 5px;
      }
    }

    &-logos {
      display: grid;
      grid-template-columns: 1fr auto;

      .mcaffree {
        width: 171px;
      }

      .academic {
        width: 81px;
      }
    }

    &-text {
      margin-top: 20px;
      font-size: 10px;

      p {
        padding: 0!important;
      }

      a {
        color: var(--fb-blue);
      }
    }

    @media #{$mobile} {
      display: block;
    }

    @media #{$desktop} {
      display: none;
    }
  }
</style>
